<template>
  <div style="height: 400px; line-height: 400px; font-size: 60px">
    <strong>welcome to wms</strong>

    <!-- <div id='pdf'>
      <pdf :src="links[0]" ref="printPdf" style="display:inline-block;width:100%" @page-loaded="pdfLoaded"></pdf>
    </div>
    <button style="position: fixed;top: 100px;" @click="test">pdf</button> -->
  </div>
</template>

<script>
// import { margePDF } from '@/utils/autoPrint.js'
// import { Loading } from "element-ui";
// import pdf from 'vue-pdf-signature'
// import CMapReaderFactory from 'vue-pdf-signature/src/CMapReaderFactory'
export default {
  name: "welcome",
  inject: ['cleanKeepCache'],
  watch: {
    $route: function (newVal) {
      const { path, query: { isRefresh } } = newVal
      if (path === '/welcome' && isRefresh) {
        this.cleanKeepCache()
        location.reload(true)
      }
    }
  },
  // components: { pdf },
  data() {
    return {
      // links: [],
      // num:0
    }
  },
  methods: {
    // test() {
    //   let loadingInstance = Loading.service({ text: '加载中' });
    //   this.links = []
    //   let comp = pdf.createLoadingTask({
    //     url: this.num>0?'https://theckbstest.oss-cn-hangzhou.aliyuncs.com/THExpressLabel1667273321084.pdf?response-content-type=application/pdf':'https://theckbstest.oss-cn-hangzhou.aliyuncs.com/YTGJExpressLabel1666779784505.pdf', // url:"",
    //     cMapPacked: true,
    //     CMapReaderFactory
    //   })
    //   this.links.push(comp)
    //   this.num += 1
    // },
    // pdfLoaded() {
    //   let loadingInstance = Loading.service({ text: '加载中' });
    //   this.$refs.printPdf.print()
    //   loadingInstance.close()
    // },
  },
  async mounted() {
    // const a = await margePDF(['https://static-s.theckb.com/BusinessMarket/wms/1.pdf','https://static-s.theckb.com/BusinessMarket/wms/2.pdf'])
    // window.open(a)
  },
}
</script>

<style scoped>
/* #pdf {
  position: fixed;
  top: 700px;
  left: 0;
  width: 100vw;
  z-index: -1;
} */
</style>